import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";

export const AdminPricing = ({ settings, onSave }) => {
  const [price, setPrice] = useState(settings.extra_photo_price);
  const [free, setFree] = useState(settings.free_photos_on_signup);
  const [freeMain, setFreeMain] = useState(settings.free_photo_in_main_contests);
  const [packs, setPacks] = useState(settings.packages);

  const setPack = (i, k, v) => setPacks(packs.map((p, j) => (j === i ? { ...p, [k]: v } : p)));
  const addPack = () => setPacks([...packs, { id: `pack${Date.now()}`, name: "Novo pacote", photos: 3, price: 19.9 }]);

  const save = () => onSave({
    extra_photo_price: Number(price),
    free_photos_on_signup: Number(free),
    free_photo_in_main_contests: freeMain,
    packages: packs.map((p) => ({ ...p, photos: Number(p.photos), price: Number(p.price) })),
  });

  return (
    <div className="grid gap-6 lg:grid-cols-12">
      <div className="glass space-y-5 rounded-xl p-6 lg:col-span-5">
        <h2 className="font-display text-2xl font-black uppercase">Fotos</h2>
        <div className="space-y-1.5"><Label>Preço por foto extra (R$)</Label><Input data-testid="pricing-extra-photo-price" type="number" step="0.01" min="0.5" value={price} onChange={(e) => setPrice(e.target.value)} /></div>
        <div className="space-y-1.5"><Label>Fotos grátis no cadastro</Label><Input data-testid="pricing-free-photos" type="number" min="0" max="20" value={free} onChange={(e) => setFree(e.target.value)} /></div>
        <div className="flex items-center justify-between gap-4 rounded-xl border border-white/10 p-4">
          <div><p className="font-semibold">Foto grátis nos concursos principais</p><p className="text-xs text-slate-400">Desligado: só fotos pagas disputam os principais</p></div>
          <Switch data-testid="pricing-free-in-main" checked={freeMain} onCheckedChange={setFreeMain} />
        </div>
      </div>
      <div className="glass space-y-4 rounded-xl p-6 lg:col-span-7">
        <div className="flex items-center justify-between">
          <h2 className="font-display text-2xl font-black uppercase">Pacotes de fotos</h2>
          <button data-testid="pricing-add-package" onClick={addPack} className="flex items-center gap-1.5 rounded-full border border-cyan-400/40 px-4 py-2 text-xs hover:bg-cyan-400/10"><Plus className="h-3.5 w-3.5" /> Adicionar</button>
        </div>
        {packs.map((p, i) => (
          <div key={p.id} className="grid grid-cols-12 items-end gap-3 rounded-xl border border-white/10 p-4" data-testid={`pricing-package-row-${i}`}>
            <div className="col-span-12 space-y-1.5 sm:col-span-5"><Label>Nome</Label><Input data-testid={`pricing-package-name-${i}`} value={p.name} onChange={(e) => setPack(i, "name", e.target.value)} /></div>
            <div className="col-span-5 space-y-1.5 sm:col-span-3"><Label>Fotos</Label><Input data-testid={`pricing-package-photos-${i}`} type="number" min="1" value={p.photos} onChange={(e) => setPack(i, "photos", e.target.value)} /></div>
            <div className="col-span-5 space-y-1.5 sm:col-span-3"><Label>Preço (R$)</Label><Input data-testid={`pricing-package-price-${i}`} type="number" step="0.01" value={p.price} onChange={(e) => setPack(i, "price", e.target.value)} /></div>
            <button data-testid={`pricing-package-remove-${i}`} onClick={() => setPacks(packs.filter((_, j) => j !== i))} className="col-span-2 flex h-10 items-center justify-center rounded-md border border-white/10 hover:border-red-400 hover:text-red-400 sm:col-span-1"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      <button data-testid="pricing-save-btn" onClick={save} className="btn-neon rounded-full py-3.5 font-semibold lg:col-span-12">Salvar preços</button>
    </div>
  );
};
